import React, { useState, useEffect } from "react";

export default function CodeChallenge() {
  
const questions = [
  {
    code: String.raw`for i in range(n):
    for j in range(i):
        print(i, j)`,
    question: "What’s the time complexity?",
    options: { A: "O(n)", B: "O(n log n)", C: "O(n²)", D: "O(n³)" },
    answer: "C",
    explanation: "Sum of 1+2+3…+n ≈ n²/2 → O(n²)."
  },

  {
    code: String.raw`while n > 1:
    n = n // 2`,
    question: "What’s the time complexity?",
    options: { A:"O(log n)", B:"O(n)", C:"O(n²)", D:"O(1)" },
    answer: "A",
    explanation: "n is halved each step → logarithmic."
  },

  {
    code: String.raw`for i in range(n):
    for j in range(n*n):
        print(i, j)`,
    question: "What’s the time complexity?",
    options: { A:"O(n)", B:"O(n²)", C:"O(n³)", D:"O(n⁴)" },
    answer: "C",
    explanation: "Outer loop n, inner loop n² → total n³."
  },

  {
    code: String.raw`print(arr[n-1])`,
    question: "Accessing last element of array is?",
    options: { A:"O(1)", B:"O(log n)", C:"O(n)", D:"O(n²)" },
    answer: "A",
    explanation: "Index lookup is constant time."
  },

  {
    code: String.raw`for i in arr:
    if i % 2 == 0:
        print(i)`,
    question: "Worst-case time complexity?",
    options: { A:"O(log n)", B:"O(1)", C:"O(n)", D:"O(n²)" },
    answer: "C",
    explanation: "Must check each element → linear."
  },

  {
    code: String.raw`for i in range(n):
    for j in range(log_n):  # log_n = log n
        print(i, j)`,
    question: "Time complexity (log_n = log n)?",
    options: { A:"O(n)", B:"O(n log n)", C:"O(log n)", D:"O(n²)" },
    answer: "B",
    explanation: "Combined loop → n × log n."
  },

  {
    code: String.raw`for i in range(n):
    print(sum(arr))`,
    question: "Time complexity if sum(arr) = O(n)?",
    options: { A:"O(n)", B:"O(n²)", C:"O(log n)", D:"O(1)" },
    answer: "B",
    explanation: "sum() is O(n) → inside loop n times → n²."
  },

  {
    code: String.raw`min(arr)`,
    question: "What’s the time complexity?",
    options: { A:"O(1)", B:"O(n)", C:"O(n log n)", D:"O(log n)" },
    answer: "B",
    explanation: "Must scan entire array."
  },

  {
    code: String.raw`You repeatedly increase i by 3 until it reaches n.`,
    question: "What’s the time complexity?",
    options: { A:"O(n)", B:"O(log n)", C:"O(n/3)", D:"O(√n)" },
    answer: "A",
    explanation: "Linear growth with constant step → O(n)."
  },

  {
    code: String.raw`for i in range(n):
    for j in range(sqrt_n):  # sqrt_n = √n
        print(i, j)`,
    question: "Time complexity?",
    options: { A:"O(n)", B:"O(n√n)", C:"O(√n)", D:"O(n²)" },
    answer: "B",
    explanation: "n × √n = n√n."
  }
];



  const [current, setCurrent] = useState(0);
  const [score, setScore] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [typing, setTyping] = useState("");

  // Typewriter effect
  useEffect(() => {
    const text = questions[current].code;
    let i = 0;
    setTyping("");

    const interval = setInterval(() => {
      // setTyping(prev => prev + text.charAt(i));
      i++;
      setTyping(text.slice(0, i));
      if (i >= text.length) clearInterval(interval);
    }, 30);

    return () => clearInterval(interval);
  }, [current]);

  const checkAnswer = (choice) => {
    const q = questions[current];

    if (choice === q.answer) {
      setScore(score + 1);
      setFeedback(`✅ Correct! ${q.explanation}`);
    } else {
      setFeedback(`❌ Oops! Correct answer: ${q.answer}) ${q.options[q.answer]}. ${q.explanation}`);
    }
  };

  const nextQuestion = () => {
    if (current + 1 < questions.length) {
      setCurrent(current + 1);
      setFeedback("");
    }
  };

  const restartGame = () => {
    setCurrent(0);
    setScore(0);
    setFeedback("");
  };

  const endScreen = current >= questions.length;

  // INLINE STYLES
  const styles = {
    body: {
      margin: 0,
// background: "radial-gradient(circle, #27acd4ff 0%, #467274ff 40%, #000000ff 100%)",
background: "linear-gradient(160deg, #000000, #1a1a1a 40%, #000000ff)",
      height: "100%",
      color: "#fff",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      fontFamily: "Courier New, monospace",
    },
    container: {
      textAlign: "center",
      width: "90%",
      maxWidth: "800px",
    },
    codeBox: {
      background: "#111",
      border: "2px solid rgba(255, 30, 0, 1)",
      borderRadius: "12px",
      padding: "20px",
      textAlign: "left",
      color: "#00ffcc",
      whiteSpace: "pre-wrap",
      minHeight: "120px",
      boxShadow: "0 0 20px rgba(255, 30, 0, 1)",
      marginBottom: "20px",
      whiteSpace: "pre-wrap",
      overflow: "visible",
      lineHeight: "1.4",
      letterSpacing: "0.5px",
      textShadow: "none"

    },
    button: {
      padding: "15px",
      borderRadius: "15px",
      border: "2px solid #fff",
      fontSize: "1.2em",
      cursor: "pointer",
      background: "none",
      transition: "0.3s",
      width: "100%",
      marginTop: "10px",
    },
    nextBtn: {
      marginTop: "20px",
      padding: "15px 30px",
      fontSize: "1.2em",
      backgroundColor: "#00e6ff",
      border: "none",
      borderRadius: "10px",
      cursor: "pointer",
    },
  };

  if (endScreen) {
    return (
      <div style={styles.body}>
        <h1>You scored {score} / {questions.length}</h1>
        <button style={styles.nextBtn} onClick={restartGame}>Play Again 🔁</button>
      </div>
    );
  }

  return (
    <div style={styles.body}>
      <div style={styles.container}>
        <h3  style={{ color:"orange"  }}  >⚡ Code & Choose Challenge</h3>

        <pre style={styles.codeBox}><code>{typing}</code></pre>


        <h2 style={{ color: "#fa0d0dff" }}>{questions[current].question}</h2>

        <button style={{...styles.button, borderColor:"#e45c5cff", color:"#00bfff"}} onClick={() => checkAnswer("A")}>
          A) {questions[current].options.A}
        </button>

        <button style={{...styles.button, borderColor:"#f14741ff", color:"#ff69b4"}} onClick={() => checkAnswer("B")}>
          B) {questions[current].options.B}
        </button>

        <button style={{...styles.button, borderColor:"#f33d25ff", color:"#00ff7f"}} onClick={() => checkAnswer("C")}>
          C) {questions[current].options.C}
        </button>

        <button style={{...styles.button, borderColor:"#f04325ff", color:"#ffff66"}} onClick={() => checkAnswer("D")}>
          D) {questions[current].options.D}
        </button>

        <div style={{ marginTop:"20px", minHeight:"40px" }}>{feedback}</div>

        <div><button style={styles.nextBtn} onClick={nextQuestion}>Next ➡️</button></div>
      </div>
    </div>
  );
}
